import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/evisearch/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { evisearchBaseQuery } from './baseQuery';

const FIVE_MINUTES = 5 * 60;

export const EVISEARCH_API_REDUCER_PATH = 'api/evisearch' as const;

export const evisearchApiRoot = createApi({
  reducerPath: EVISEARCH_API_REDUCER_PATH,
  baseQuery: evisearchBaseQuery,
  keepUnusedDataFor: FIVE_MINUTES,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
